import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, CAL_URL } from "../../../configs/WebServiceUrl";
import {apiKeyHeader} from "../../../configs/ApiKeys"
// const BASE_URL = "https://web1024.docmaster.in:5010"
// const BASE_URL = "http://localhost:5010";

const api=axios

export const fetchProjectsThunk = createAsyncThunk(
  "projects/fetchProjects",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/project/list_of_projects/${user_id}`);
      return response.data; // should be an array
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitProjectsThunk = createAsyncThunk(
  "projects/submitProjects",
  async ({ projectPayloads }, { rejectWithValue }) => {
    try {
      const results = [];

      for (const payload of projectPayloads) {
        const response = await api.post(`${BASE_URL}/project`, payload);
        results.push(response.data);
      }

      return results;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchEventDetailsThunk = createAsyncThunk(
  "projects/fetchEventDetails",
  async ({ category_id, event_id , language}, { rejectWithValue }) => {
    try {
      console.log("🚀 fetchEventDetailsThunk called with:", { category_id, event_id });
      const response = await api.get(
        `${CAL_URL}/competition/details?category_id=${category_id}&event_id=${event_id}&language=${language}`
      );
      console.log("🛬 Response from backend:", response.data);
      return {
        category_id,
        data: {
          faqs: Array.isArray(response.data) ? response.data : [],
        },
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchSpeechThunk = createAsyncThunk(
  "projects/fetchSpeech",
  async ({ category_id, event_id , language}, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${CAL_URL}/competition/speech?category_id=${category_id}&event_id=${event_id}&language=${language}`
      );
      return {
        category_id,
        data: {
          speeches: Array.isArray(response.data) ? response.data : [],
        },
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchActivitiesThunk = createAsyncThunk(
  "projects/fetchActivities",
  async ({ category_id, event_id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${CAL_URL}/competition/activities?category_id=${category_id}&event_id=${event_id}`
      );
      return {
        category_id,
        data: {
          activities: Array.isArray(response.data) ? response.data : [],
        },
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchProjectsForEventThunk = createAsyncThunk(
  "projects/fetchProjectsForEvent",
  async ({ category_id, event_id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${CAL_URL}/competition/projects?category_id=${category_id}&event_id=${event_id}`
      );
      return {
        category_id,
        data: Array.isArray(response.data) ? response.data : [],
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

